<div
  class="free-trial-banner"
  [ngClass]="urgencyLevel"
  data-testid="free-trial-banner">

  <div class="left-content">
    <div class="status-chip" data-testid="free-trial-status-chip">
      <app-calendar-outline-icon *ngIf="!isTrialEnded" class="calendar-icon" />
      <app-calendar-x-icon *ngIf="isTrialEnded" class="calendar-icon" />
      <span data-testid="free-trial-banner-text">{{ statusText }}</span>
    </div>

    <span class="promotional-text">{{ promotionalText }}</span>
  </div>

  <button
    class="upgrade-button"
    (click)="onUpgradeClick()"
    data-testid="free-trial-upgrade-button">
    <span class="button-text">{{ buttonText }}</span>
    <app-crown-outline-icon class="crown-icon" />
  </button>
</div>
